import { Box, Button, Typography } from "@mui/material";

import { downloadPresentation, openPatGuide } from "../utils";
import { handleBackToWebsiteBtn } from "utils";
import { DownloadMaterialCard } from "../DownloadMaterialCard";
import RhCajuImage from "assets/images/rh-caju-coracao-coreano.svg";
import { EnumGTMEvents } from "services/tagManager/enums/enumGTMEvents";
import { TagManagerService } from "services/tagManager";

interface PresentationCardProps {
  employeesNumber?: number | "";
}

export function PresentationCard(props: PresentationCardProps) {
  const handleDownloadPresentation = () => {
    downloadPresentation();
    TagManagerService.push(
      EnumGTMEvents.CONFIRMATION_INFO_PRESENTATION_BTN_DOWNLOAD__CLICK,
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#f3f3f3",
          border: "1px solid rgba(211, 211, 211, 0.6)",
          borderRadius: 3.5,
          p: { xs: 2, md: 3 },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 3,
          mb: 3,
        }}
      >
        <DownloadMaterialCard
          variant="presentation"
          title="Prepare-se para conhecer mais a Caju"
          description="Baixe a apresentação comercial da Caju e já deixe suas dúvidas anotadas para a nossa reunião."
          buttonText="Baixar apresentação"
          onDownloadClick={handleDownloadPresentation}
          ariaLabel="Baixar apresentação comercial da Caju"
          image={RhCajuImage}
        />
        <DownloadMaterialCard
          variant="pat"
          title={
            <>
              Manual do PAT:
              <br />
              Tudo o que você precisa saber sobre o novo decreto
            </>
          }
          description={
            <>
              Um conteúdo essencial para RH e DP que querem mais{" "}
              <strong>segurança, conformidade e eficiência na gestão</strong> de
              benefícios
            </>
          }
          buttonText="Baixar material sobre o PAT"
          onDownloadClick={openPatGuide}
          ariaLabel="Baixar guia sobre o novo decreto do PAT"
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
        <Button
          variant="text"
          sx={{ color: "dark.main" }}
          aria-label="Voltar para o site da Caju"
          startIcon={
            <i
              className="uil uil-arrow-left"
              style={{ fontSize: 24, display: "flex" }}
              aria-hidden="true"
            />
          }
          onClick={() =>
            handleBackToWebsiteBtn(
              "https://www.caju.com.br",
              EnumGTMEvents.LAST_PAGE_BACKWARD_BTN_HOME_PAGE__CLICK,
            )
          }
        >
          <Typography
            sx={{
              textDecoration: "underline",
              display: { xs: "none", md: "block" },
            }}
            variant="subtitle2"
          >
            Voltar para o site
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              fontSize: 14,
              textDecoration: "underline",
              display: { md: "none" },
            }}
          >
            Site
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}
